/* 🤖 this file was generated by svg-to-ts */
export const DfIconCaretDown12: {
  name: 'caret-down-12';
  data: string;
} = {
  name: 'caret-down-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M5.602 7.816 3.106 4.77a.462.462 0 0 1 .088-.67.522.522 0 0 1 .31-.101h4.992c.278 0 .504.214.504.478 0 .106-.037.21-.106.293L6.398 7.816a.522.522 0 0 1-.796 0z"/></svg>`
};
